<template>
	<BModal :visible="show" title="Sign in" :static="true" @hide="closeModal">
		<p>
			If you have shopped with us before, please enter your details below.
			If you are a new customer, please proceed to the Step 1 section.
		</p>
		<LoginForm
			:open-forgot-password-in-new-tab="true"
			@success="handleSuccess"
		/>
	</BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import LoginForm from '@component/user-backend/Forms/LoginForm.vue';

export default {
	components: {
		LoginForm,
		BModal,
	},
	props: {
		show: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		closeModal() {
			this.$emit('close-modal');
		},
		handleSuccess() {
			this.$emit('success');
		},
	},
};
</script>

<style lang="scss">
.modal-backdrop {
	opacity: 0.5;
}

.modal-footer {
	display: none;
}
</style>
